<div class="container">
  <header class="page-heading mb-lg">
    <span class="legal-eyebrow">Legal</span>
    <h1>Terms of Service</h1>
    <p>Last updated: {{ lastUpdated }}</p>
  </header>

  <section class="card mb-lg toc-card">
    <h2 class="section-title">On this page</h2>
    <nav class="toc-grid" aria-label="Table of contents">
      @for (s of sections; track s.id) {
        <a [routerLink]="[]" [fragment]="s.id">{{ s.title }}</a>
      }
    </nav>
  </section>

  <section class="card legal-content">
    @for (s of sections; track s.id) {
      <article class="legal-section" [id]="s.id">
        <h2>{{ s.title }}</h2>
        @for (p of s.paragraphs; track p) {
          <p>{{ p }}</p>
        }
        @if (s.bullets) {
          <ul>
            @for (b of s.bullets; track b) {
              <li>{{ b }}</li>
            }
          </ul>
        }
        @if (s.contactLink) {
          <p><a routerLink="/contact">Go to our Contact page</a> to get in touch.</p>
        }
      </article>
    }
  </section>

  <p class="legal-footnote">
    See also our <a routerLink="/privacy">Privacy Policy</a> and
    <a routerLink="/disclaimer">Disclaimer</a>, or <a routerLink="/">return home</a>.
  </p>
</div>
